import styled from 'styled-components'
import { Link } from 'react-router-dom';

export const StyledHeader = styled.header`
    display: flex;
    justify-content: center;
`;

export const HeaderContainer = styled.div`
    width: 89%;
    margin-top: 10px;
    margin-bottom: 10px;
`;


export const LogoImg = styled.img`
    width: auto;
    height: 4.5rem;
    margin: 0.25rem;

    @media (max-width: 992px) {
        height: 2rem;
    }
`;

export const HeaderLayout = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const SupportedByBar = styled.div`
    display: flex;
    align-items: center;
    gap: 1.75rem;
    padding: 0.75rem 0;
    border-bottom: 1px solid #e5e7eb;

    @media (max-width: 992px) {
        flex-direction: column;
        gap: 0.6rem;
        padding: 0.65rem 0 0.75rem;
    }
`;

export const SupportedByLabel = styled.span`
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: #4a5568;
    white-space: nowrap;
    position: relative;
    padding-right: 1.5rem;

    &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 18px;
        width: 1px;
        background: #d1d5db;
    }

    @media (max-width: 992px) {
        padding-right: 0;
        padding-bottom: 0.5rem;

        &::after {
            top: auto;
            bottom: 0;
            right: 50%;
            transform: translateX(50%);
            height: 1px;
            width: 32px;
        }
    }
`;

export const SupportedByLogoRow = styled.div`
    display: flex;
    align-items: center;
    gap: 2.25rem;
    flex-wrap: wrap;

    @media (max-width: 992px) {
        gap: 1.25rem;
        justify-content: center;
    }
`;

export type SupportedByLogoSizing = 'extra' | 'compact' | 'zoom';

const scaleFor = (s?: SupportedByLogoSizing) =>
    s === 'extra' ? 0.85 : s === 'compact' ? 1.3 : s === 'zoom' ? 1.8 : 1;

const padXFor = (s?: SupportedByLogoSizing) => (s === 'extra' ? '0.3rem' : '0.7rem');
const padXForMobile = (s?: SupportedByLogoSizing) => (s === 'extra' ? '0.25rem' : '0.55rem');

export const SupportedByLogoTile = styled.div<{ $sizing?: SupportedByLogoSizing }>`
    height: 46px;
    padding: ${({ $sizing }) => `4px ${padXFor($sizing)}`};
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    box-sizing: border-box;
    transition: transform 0.25s ease, box-shadow 0.25s ease;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    }

    &:hover img {
        filter: grayscale(0%);
        opacity: 1;
    }

    @media (max-width: 992px) {
        height: 36px;
        padding: ${({ $sizing }) => `3px ${padXForMobile($sizing)}`};
    }
`;

export const SupportedByLogoLink = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

export const SupportedByLogo = styled.img<{ $sizing?: SupportedByLogoSizing }>`
    max-height: 100%;
    max-width: 130px;
    width: auto;
    object-fit: contain;
    transform: scale(${({ $sizing }) => scaleFor($sizing)});
    transform-origin: center;
    filter: grayscale(100%);
    opacity: 0.85;
    transition: filter 0.25s ease, opacity 0.25s ease;

    @media (max-width: 992px) {
        max-width: 100px;
    }
`;

export const HeaderNav = styled.nav`
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    padding-bottom: 20px;
`;

export const StyledLink = styled(Link)`
    color: black !important;
    text-decoration: none;
    margin-left: 1em;
    margin-right: 1em;
    &:hover {
        transform: scale(0.98);
        color: black;
    }
`;

export const HeaderLinks = styled.ul`
    list-style-type: none;
    margin-top: 15px;
    width: auto;
    display: flex;
    align-items: center;

    @media (max-width: 992px) {
        display: none;
    }
`;

export const HeaderNavButton = styled.button`
    background: #3aaa35;
    border-radius: 5px;
    border: 0;
    padding 0.5rem 1.5rem;
    color: #dedc03;
    font-weight: 750;

    &:hover {
    transform: scale(0.98);
    }
`;

export const HeaderNavLogOutButton = styled.button`
    background: #d9082a;
    border-radius: 5px;
    border: 0;
    padding 0.5rem 1.5rem;
    color: #fff;
    font-weight: 750;
    margin-left: 5px;

    &:hover {
    transform: scale(0.98);
    }
`;

export const HeaderWideMenuSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 992px) {
        justify-content: flex-end;
        display: none;
    }

    @media (min-width: 1200px) {
        width: 35%;
    }

    @media (min-width: 1400px) {
        width: 35%;
        justify-content: center;
    }
`;

export const HeaderMobileMenuSection = styled.nav`
    display: none;

    ${StyledLink} {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    @media (max-width: 992px) {
        display: block;
    }
`

export const HeaderCenterSection = styled.div`
    text-align: start;
    display: flex;
    align-items: center;

    @media (max-width: 992px) {
        text-align: center;
    }
`;

export const UserIconWrapper = styled.div`
    height: 50px;
    width: 50px;
    border: solid 2px black;
    background-color: white;
    border-radius: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
        transform: scale(0.98);
    }
`

export const UserIcon = styled.img`
    height: 30px;
    width: 30px;
`;
